import cx from 'classnames';
import { FC, PropsWithChildren } from 'react';
import { CatLayoutContainer } from '@blocks-react/components/LayoutContainer';
import styles from './HeaderRow.module.scss';

export const HeaderRow: FC<PropsWithChildren> = ({ children }) => (
  <CatLayoutContainer>
    <div 
      className={cx(
        styles['shopping_cart'],
        'd-flex align-items-center justify-content-between',
        styles['header-row']
      )}
    >
      {children}
    </div>
  </CatLayoutContainer>
);
